
    import Component from 'vue-class-component';
    import {
        QualificationRequirementViewModel,
        QualificationViewModel,
        RequirementsClient, SpecialityType
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import RequirementSummary from "@/features/applications/components/RequirementSummary";
    import EducationalQualificationDetailsContent
        from "@/features/documents/qualifications/views/EducationalQualificationDetailsContent.vue";
    import TrainingQualificationDetailsContent
        from "@/features/documents/qualifications/views/TrainingQualificationDetailsContent.vue";

    @Component({
        components: {
            TrainingQualificationDetailsContent,
            EducationalQualificationDetailsContent
        }
    })
    export default class QualificationRequirementSummary extends RequirementSummary {

        @Prop({required: true})
        requirement!: QualificationRequirementViewModel;

        chosenQualifications: QualificationViewModel[] | null = null;

        get showIndex() {
            return this.chosenQualifications ? this.chosenQualifications!.length > 1 : false;
        }

        async created() {
            if (this.requirementValue) {
                this.chosenQualifications = await new RequirementsClient().chosenQualifications(this.application.id, this.requirement.id);
            }
        }

        componentName(qualification: QualificationViewModel) {
            switch (qualification.specialityType) {
                case SpecialityType.Training:
                    return "TrainingQualificationDetailsContent";
                case SpecialityType.Educational:
                    return EducationalQualificationDetailsContent;
                default:
                    throw `Unknown speciality type: ${qualification.specialityType}`
            }
        }
    }
